module.exports = __webpack_public_path__ + "static/media/attend_event_map.2b314b56.svg";